(function () {
  'use strict';

  angular.module('wsLrs.directives').directive('icon', [function () {
    return {
      restrict: 'E',
      scope: true,
      replace: true,
      template: "\n                <i class=\"{{ iconClasses }}\"></i>\n            ",
      link: function link(scope, elem, attrs) {
        var iconClasses = attrs.iconClasses,
          type = attrs.type,
          animate = attrs.animate,
          size = attrs.size;
        scope.iconClasses = 'fas';
        if (iconClasses) {
          scope.iconClasses = "".concat(scope.iconClasses, " ").concat(iconClasses);
        }
        if (type) {
          scope.iconClasses = "".concat(scope.iconClasses, " fa-").concat(type);
        }
        if (size) {
          scope.iconClasses = "".concat(scope.iconClasses, " fa-").concat(size);
        }
        switch (animate) {
          case 'rotate':
            scope.iconClasses = "".concat(scope.iconClasses, " fa-spin");
            break;
          default:
            return;
        }
      }
    };
  }]);
})();
